import { useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { syncMe } from './lib/api';
import { HomeRoute } from './routes/Home';
import { TokenRoute } from './routes/Token';
import { WalletRoute } from './routes/Wallet';
import { RoyaltiesRoute } from './routes/Royalties';

function TabBar() {
  const location = useLocation();
  const tabs = [
    { path: '/', label: 'Токены' },
    { path: '/royalties', label: 'Комиссии' },
    { path: '/wallet', label: 'Кошелёк' },
  ];
  return (
    <nav
      style={{
        position: 'sticky',
        bottom: 0,
        background: 'var(--bg)',
        borderTop: '1px solid var(--border)',
        display: 'flex',
        padding: '8px 16px env(safe-area-inset-bottom, 8px)',
        gap: 8,
      }}
    >
      {tabs.map((t) => {
        const active = location.pathname === t.path;
        return (
          <Link
            key={t.path}
            to={t.path}
            style={{
              flex: 1,
              textAlign: 'center',
              padding: 10,
              borderRadius: 12,
              background: active ? 'var(--secondary-bg)' : 'transparent',
              color: active ? 'var(--text)' : 'var(--hint)',
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}

function TelegramReady() {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;
    try {
      tg.ready();
      tg.expand();
      tg.disableVerticalSwipes?.();
    } catch (err) {
      console.warn('Telegram WebApp init issue', err);
    }
  }, []);
  return null;
}

// CC-076 — sync user to backend on mount. This is what triggers
// upsertUser (writes users.username) and CC-070 auto-link of pending
// claim earmarks. Without this call, pending @username deploys can
// never settle to the recipient's tg_id.
function MeSync() {
  useEffect(() => {
    syncMe({}).catch((err: unknown) => {
      console.warn('postMe failed', err);
    });
  }, []);
  return null;
}

// Deep-link router: bot crafts URLs like t.me/<bot>?startapp=royalties or
// t.me/<bot>?startapp=token_<address>. The mini-app picks the start_param up
// from initDataUnsafe and navigates accordingly. Only fires once on mount.
function StartParamRouter() {
  const navigate = useNavigate();
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    const param = tg?.initDataUnsafe?.start_param;
    if (!param) return;
    if (param === 'royalties') {
      navigate('/royalties', { replace: true });
    } else if (param.startsWith('token_')) {
      const addr = param.slice('token_'.length);
      if (addr) navigate(`/token/${encodeURIComponent(addr)}`, { replace: true });
    }
    // We intentionally don't run this on every navigation — only the initial
    // landing. Otherwise re-renders would fight any user-driven navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}

export function App() {
  return (
    <BrowserRouter>
      <TelegramReady />
      <MeSync />
      <StartParamRouter />

      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
        <main style={{ flex: 1, paddingBottom: 24 }}>
          <Routes>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/token/:masterAddr" element={<TokenRoute />} />
            <Route path="/royalties" element={<RoyaltiesRoute />} />
            <Route path="/wallet" element={<WalletRoute />} />
          </Routes>
        </main>
        <TabBar />
      </div>
    </BrowserRouter>
  );
}
